import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MigrationFromReviewerV1ClosingPopupContent', {
    closingPopupMessage:
        'Please remember to migrate to "Editing on Approval" before 1st July 2025 to avoid manual set up later.',
    closeButtonText: 'Skip migration',
});
